document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.js-drawer-open-cart');
  if (!trigger) return;

  // Stop link navigation unconditionally — must happen before any early returns
  event.preventDefault();

  // Try the Impulse native mechanism (CartDrawer listens for cart:open)
  document.dispatchEvent(new CustomEvent('cart:open'));

  // Fallback: directly open drawer in case CartDrawer hasn't initialized
  var cartDrawer = document.getElementById('CartDrawer');
  if (!cartDrawer || cartDrawer.classList.contains('drawer--is-open')) return;

  cartDrawer.classList.add('drawer--is-open');
  document.documentElement.classList.add('js-drawer-open');
  trigger.setAttribute('aria-expanded', 'true');

  // Fallback close handler (used only when CartDrawer isn't managing state)
  function onDocClick(e) {
    var closeBtn = e.target.closest('.js-drawer-close');
    var inDrawer = e.target.closest('#CartDrawer');
    var isCartBtn = e.target.closest('.js-drawer-open-cart');

    if (closeBtn || (!inDrawer && !isCartBtn)) {
      cartDrawer.classList.remove('drawer--is-open');
      document.documentElement.classList.remove('js-drawer-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick);
    }
  }

  // Small delay so the current click event doesn't immediately re-trigger close
  setTimeout(function () {
    document.addEventListener('click', onDocClick);
  }, 50);
});
